<template>
    <div :class="['parallax-element', 'wow', 'fadeInUp', uniqueClass]"
         data-parallax="block"
         :data-wow-duration="speed"
         :data-speed="speed"
    >

        <img :src="icon"
             :alt="`parallax-icon_${ icon }`"
        >

    </div>
</template>

<script>
    export default {
        name: 'ParallaxBlock',
        props: {
            speed: {
                type: Number,
                default: 0.5
            },
            uniqueClass: {
                type: String,
                default: ''
            },
            image: {
                type: String,
                default: 'dotes_11x19'
            }
        },
        computed: {
            icon() {
                return require(`@/assets/images/icons/${ this.image }.svg`)
            }
        }
    }
</script>